import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import throttle from 'lodash/throttle';
import rootReducer from '../reducers';
import ravenMiddleware from './ravenMiddleware';
import { loadState, saveState } from './localStorage';

const middleware =
  process.env.REACT_APP_ENV !== 'production'
    ? [
        ravenMiddleware,
        require('redux-immutable-state-invariant').default(),
        thunk
      ]
    : [ravenMiddleware, thunk];

const store = createStore(
  rootReducer,
  loadState(),
  composeWithDevTools(applyMiddleware(...middleware))
);

store.subscribe(
  throttle(() => {
    saveState(store.getState());
  }, 1000)
);

export default store;



// WEBPACK FOOTER //
// ./src/store/configureStore.js